import { DataObject } from "core/types/DataObject";

/**
 * core/types/Voucher
 * ----------------------------------------------------------------------
 * @since     0.0.1
 */
export class Voucher extends DataObject {
  /**
   * @type {number}
   */
  voucherId = null;

  /**
   * @type {number}
   */
  subscriptionTypeId = null;

  /**
   * @type {number}
   */
  voucherProviderId = null;

  /**
   * @type {string|number}
   */
  number = null;

  /**
   * @type {string|number}
   */
  secondaryId = null;

  /**
   * @type {string|number}
   */
  dateCreated = null;

  /**
   * @type {string|number}
   */
  dateUpdated = null;

  /**
   * @type {string|number}
   */
  expiration = null;

  /**
   * @type {number}
   */
  voucherStatus = null;

  /**
   * @type {number}
   */
  subscriberId = null;

  /**
   * @type {string}
   */
  invitedEmail = null;

  /**
   * @type {string}
   */
  invitedFirstName = null;

  /**
   * @type {string}
   */
  invitedLastName = null;

  /**
   * @type {string}
   */
  giftMessage = null;

  /**
   * @param {number} voucherId 
   * @param {number} subscriptionTypeId 
   * @param {number} voucherProviderId 
   * @param {string|number} number 
   * @param {string|number} secondaryId 
   * @param {string|number} dateCreated 
   * @param {string|number} dateUpdated 
   * @param {string|number} expiration 
   * @param {number} voucherStatus 
   * @param {number} subscriberId 
   * @param {string} invitedEmail 
   * @param {string} invitedFirstName 
   * @param {string} invitedLastName 
   * @param {string} giftMessage 
   */
  constructor (
    voucherId = null,
    subscriptionTypeId = null,
    voucherProviderId = null,
    number = null,
    secondaryId = null,
    dateCreated = null,
    dateUpdated = null,
    expiration = null,
    voucherStatus = null,
    subscriberId = null,
    invitedEmail = null,
    invitedFirstName = null,
    invitedLastName = null,
    giftMessage = null
  ) {
    super();

    this.voucherId = voucherId || null;
    this.subscriptionTypeId = subscriptionTypeId || null;
    this.voucherProviderId = voucherProviderId || null;
    this.number = number || null;
    this.secondaryId = secondaryId || null;
    this.dateCreated = dateCreated || null;
    this.dateUpdated = dateUpdated || null;
    this.expiration = expiration || null;
    this.voucherStatus = voucherStatus || null;
    this.subscriberId = subscriberId || null;
    this.invitedEmail = invitedEmail || null;
    this.invitedFirstName = invitedFirstName || null;
    this.invitedLastName = invitedLastName || null;
    this.giftMessage = giftMessage || null;
  }
}
